"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _LayoutList = _interopRequireDefault(require("./LayoutList"));

var _LayoutGrid = _interopRequireDefault(require("./LayoutGrid"));

var _LayoutSlideshow = _interopRequireDefault(require("./LayoutSlideshow"));

var _ModuleMedia = _interopRequireDefault(require("./ModuleMedia"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const layouts = {
  "list": _LayoutList.default,
  "grid": _LayoutGrid.default,
  "slideshow": _LayoutSlideshow.default
};
const useStyles = (0, _styles.makeStyles)(theme => ({
  media: {
    position: "relative"
  }
}));

const ArticleMedia = ({
  className,
  language = "no",
  layout = "grid",
  media = [],
  mediaWidth = 180,
  mediaHeight = 180
}) => {
  const localeId = "locale:" + language;
  const classes = useStyles({
    mediaWidth,
    mediaHeight
  });

  const renderMedia = ({
    media,
    mediaSize,
    mediaFormat,
    content
  }) => {
    const mediaType = media && media.mediaType;
    let headline = content && content.headline || media && media.content && media.content.headline || undefined;
    let caption = content && content.caption || media && media.content && media.content.caption || undefined;
    const byline = content && content.byline || media && media.content && media.content.byline || undefined;
    const license = content && content.license || media && media.content && media.content.license || undefined;

    if (typeof headline === "object") {
      headline = headline[localeId] || undefined;
    }

    if (typeof caption === "object") {
      caption = caption[localeId] || undefined;
    }

    return _react.default.createElement(_ModuleMedia.default, _extends({}, media, {
      size: mediaSize,
      mediaFormat: mediaFormat,
      headline: headline,
      caption: caption,
      byline: byline,
      license: license
    }));
  };

  if (!media.length) {
    return false;
  }

  const LayoutTemplate = layout && layouts[layout];

  if (LayoutTemplate) {
    return _react.default.createElement(LayoutTemplate, null, media.map(media => renderMedia(media)));
  }

  return _react.default.createElement("div", {
    className: className
  }, media.map(media => renderMedia(media)));
};

var _default = ArticleMedia;
exports.default = _default;
module.exports = exports.default;